/**
 * Centralized inline styles for PrintOrderInfo component
 * Optimized for thermal receipt printers (58mm and 80mm paper widths)
 */

import { CSSProperties } from "react";

export const printStyles = {
  // Container
  wrapper: {
    width: "100%",
    // maxWidth: "80mm", // Max for 80mm paper
    // minWidth: "48mm", // Min for 58mm paper printable area
    fontFamily: "Arial, sans-serif",
    fontSize: "12px",
    lineHeight: "1.4",
    color: "#000",
    backgroundColor: "#fff",
    margin: "0 auto",
  } as CSSProperties,

  // Logo section
  logoSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "4px",
    paddingTop: "4px",
  } as CSSProperties,

  // Section titles (ALL CAPS)
  sectionTitle: {
    fontSize: "12px",
    fontWeight: "bold",
    textTransform: "uppercase" as const,
    letterSpacing: "0.5px",
    marginBottom: "6px",
    paddingTop: "4px",
  } as CSSProperties,

  // Order header section
  orderHeaderSection: {
    marginBottom: "4px",
  } as CSSProperties,

  orderHeaderTitle: {
    fontSize: "12px",
    fontWeight: "bold",
    textTransform: "uppercase" as const,
    letterSpacing: "0.5px",
    marginBottom: "6px",
    paddingTop: "4px",
  } as CSSProperties,

  // Flex row for order badge + stats
  orderHeaderRow: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    gap: "12px",
    marginBottom: "4px",
  } as CSSProperties,

  // Inverted order badge
  orderBadge: {
    backgroundColor: "#000",
    color: "#fff",
    padding: "10px 14px",
    fontSize: "22px",
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif",
    display: "inline-block",
    borderRadius: "12px",
    flexShrink: 0,
    // Critical for printing black backgrounds
    WebkitPrintColorAdjust: "exact" as const,
    printColorAdjust: "exact" as const,
  } as CSSProperties,

  // Order stats (right side of badge)
  orderStats: {
    flex: 1,
    fontSize: "12px",
  } as CSSProperties,

  orderStatRow: {
    marginBottom: "2px",
  } as CSSProperties,

  // Labels and values
  label: {
    fontSize: "12px",
    fontWeight: "normal",
  } as CSSProperties,

  value: {
    fontSize: "12px",
    fontWeight: "bold",
  } as CSSProperties,

  // Divider (use with <hr> element)
  divider: {
    border: "none",
    borderTop: "1px solid #000",
    margin: "12px 0",
    width: "100%",
    height: "0",
  } as CSSProperties,

  // Generic section
  section: {
    marginBottom: "4px",
  } as CSSProperties,

  // Field row
  fieldRow: {
    fontSize: "12px",
    marginBottom: "2px",
  } as CSSProperties,

  // Pharmacist section specific
  pharmacistThankYou: {
    fontSize: "12px",
    lineHeight: "1.5",
    marginBottom: "6px",
    paddingTop: "4px",
  } as CSSProperties,

  pharmacistDisclaimer: {
    fontSize: "10px",
    color: "#000",
    lineHeight: "1.4",
    marginTop: "6px",
  } as CSSProperties,

  // Flex row for pickup info + QR
  pickupFlexRow: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "8px",
  } as CSSProperties,

  pickupInfo: {
    flex: 1,
    minWidth: 0, // Enable text truncation
  } as CSSProperties,

  verificationCode: {
    fontSize: "18px",
    fontWeight: "bold",
    letterSpacing: "1px",
    fontFamily: "monospace",
    border: "1px dashed #000",
    borderRadius: "8px",
    padding: "4px 8px",
    display: "inline-block",
    // marginTop: "4px",
  } as CSSProperties,

  // QR code container
  qrContainer: {
    width: "90px",
    height: "90px",
    flexShrink: 0,
    border: "1px solid #000",
    padding: "4px",
    boxSizing: "border-box" as const,
  } as CSSProperties,

  // QR code with label wrapper (flex column)
  qrWithLabel: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    flexShrink: 0,
  } as CSSProperties,

  // QR label text (above QR code)
  qrLabel: {
    fontSize: "10px",
    marginBottom: "4px",
    textAlign: "center" as const,
    color: "#000",
  } as CSSProperties,

  // Payment instructions (below QR)
  paymentInstructions: {
    fontSize: "10px",
    color: "#666",
    lineHeight: "1.4",
    marginTop: "8px",
  } as CSSProperties,

  // Pickup instructions (for non-delivery orders)
  pickupInstructionsBox: {
    marginBottom: "12px",
    padding: "10px",
    backgroundColor: "#f8f9fa",
    border: "1px solid #dee2e6",
    fontSize: "12px",
    lineHeight: "1.5",
  } as CSSProperties,
};
